/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Table,
  Button
} from 'reactstrap';

import ModalConfirmation from 'components/Modal/ConfirmationModal';
import Loader from 'components/Loader';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import Pagination from 'components/Pagination';

import SalesProcessService from '../service';

import { useListSalesProcesses } from '../hooks/useListSalesProcesses';
import { toast } from 'react-toastify';

const SalesProcessList = () => {
  const [activePage, setActivePage] = useState(1);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [idSalesProcess, setIdSalesProcess] = useState(null);

  const history = useHistory();

  const {
    getSalesProcesses,
    salesProcesses,
    totalSalesProcesses,
    isLoadingSalesProcesses
  } = useListSalesProcesses();

  useEffect(() => {
    getSalesProcesses();
  }, []);

  const handlePageChange = (newPage) => {
    setActivePage(newPage);
    getSalesProcesses(newPage);
  };

  const handleEditButtonClick = useCallback((salesProcessId) => {
    history.push(`/admin/crm/salesProcess/form/${salesProcessId}`);
  });

  const handleDeleteSalesProcess = useCallback((id) => {
    SalesProcessService.delete(id)
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          'Erro ao deletar o processo de vendas';
        toast.error(message);
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getSalesProcesses(1);
      });
  }, []);

  const controlDeleteAudio = (id) => {
    setIdSalesProcess(id);
    setOpenModalConfirmation(true);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/crm/salesProcess/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Processos - Vendas</h3>
                </CardHeader>
                <CardBody>
                  {isLoadingSalesProcesses ? (
                    <div className="col-12">
                      <Row className="justify-content-md-center">
                        <Loader />
                      </Row>
                    </div>
                  ) : (
                    <Table hover={true} striped>
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th className="text-center">Editar</th>
                          <th className="text-center">Excluir</th>
                        </tr>
                      </thead>
                      <tbody>
                        {salesProcesses &&
                          salesProcesses.map((salesProcess) => {
                            return (
                              <tr key={salesProcess.id}>
                                <td>{salesProcess.name}</td>
                                <td width="10%" className="text-center">
                                  <Button
                                    size="sm"
                                    color="info"
                                    onClick={() =>
                                      handleEditButtonClick(salesProcess.id)
                                    }
                                  >
                                    <li className="fas fa-user-edit"></li>
                                  </Button>
                                </td>
                                <td width="10%" className="text-center">
                                  <Button
                                    size="sm"
                                    color="danger"
                                    onClick={() =>
                                      controlDeleteAudio(salesProcess.id)
                                    }
                                  >
                                    <li className="fas fa-trash"></li>
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={totalSalesProcesses}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>

      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idSalesProcess}
        deleteResource={handleDeleteSalesProcess}
        message={'Tem certeza que deseja excluir o processo?'}
      />
    </>
  );
};

export default SalesProcessList;
